// We should have our own permissions type for Form Index.

export let FormViewMode = /*#__PURE__*/function (FormViewMode) {
  FormViewMode["View"] = "view";
  FormViewMode["Edit"] = "edit";
  return FormViewMode;
}({});